import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { TabComponent } from '../../service/menu/tab/tab.component';
import { MenuItemsComponent } from '../../service/menu/menu-items/menu-items.component';
import { HttpClient } from '@angular/common/http';
import { InvoiceOfPersonComponent } from '../../finance/invoice-of-person/invoice-of-person.component';
import { CardexDetaileComponent } from '../../wharehouse/wharehouse-cardex/cardex-detaile/cardex-detaile.component';
import { FinanaceCardexDetaileComponent } from '../../finance/finanace-cardex-detaile/finanace-cardex-detaile.component';
import { MyProfileComponent } from '../../user/my-profile/my-profile.component';
import { MessageService } from '../../service/message/message.service';
import { AccountRenewalComponent } from '../account-renewal/account-renewal.component';
import { FinanceCardexPersonnelDetaileComponent } from '../../finance/finance-cardex-personnel/finance-cardex-personnel-detaile/finance-cardex-personnel-detaile.component';
import { DOCUMENT } from '@angular/common';
import { AccountRenewal2Component } from '../account-renewal2/account-renewal2.component';
import { BuyChargeComponent } from '../buy-charge/buy-charge.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public user_logo!: string;
  public site!: string;
  public sms_access: boolean = false;
  public code: number;
  public user_id: number | undefined;
  public list_tab: any = [];
  public list_tab_temp: any = [];
  public tab_id: number = 156;
  public list_section: any = [];
  public list_section_temp: any = [];
  public list_rstatus_in_menu: any = [];
  public list_rstatus: any = [];
  public rstatus_id: number | undefined;
  public list_menu: any = [];
  public list_menus: any = [];
  public setting_menu: boolean = false;
  public admin: number | undefined;
  public services_id: number | undefined;
  public show_extra_menu: boolean = true;
  public menu_id: number | undefined;
  public menu_id_temp: number | undefined;
  public user_creator: number | undefined
  public refrerr: any | undefined;
  public search_finance: string;
  public search_finance_cardex: string;
  public search_finance_cardex_persennel: any = [];
  public search_finance_newspaper: string;
  public search_material: string;
  public level: number | undefined;
  public creator: number | undefined;
  public similar_admin: number;
  public expire: boolean | undefined;
  public expire_date!: string;
  public user_setting_menu: number | undefined;
  public sms_charge: number = 0;
  public sms_charge2: number = 0;
  public loading2: boolean = false;
  public amount: number;
  public amount2: number = 0;
  public account_title: string | undefined;
  public account_price: number = 0;
  public account_month: number = 1;
  public p3: string | undefined;
  public p7: string | undefined;
  public now_date!: string;
  public token_login: any | undefined;
  constructor(
    public router: Router,
    public serverService: ServerService,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public http: HttpClient,
    public messageService: MessageService,
    public activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) public document: any
  ) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.user_logo = this.serverService.get_default_user_logo();
    this.site = this.serverService.get_site();
    this.serverService.get_services_id().subscribe(
      (res) => {
        this.get_services_id(res);
      }
    )
    this.serverService.get_reset_services_id().subscribe(
      (res) => {
        this.rstatus_id = 0;
      }
    )
    this.serverService.get_sms_charge().subscribe(
      () => {
        this.get_sms_charge();
      }
    )
    this.serverService.get_account_charge().subscribe(
      () => {
        this.get_expire_date();
      }
    )
    this.serverService.get_menu2().subscribe(
      (res) => {
        this.list_tab = [];
        this.list_tab_temp = [];
        this.list_menus = [];
        this.list_section = [];
        this.get_tab();
      }
    )
  }
  select(id: number) {
    this.tab_id = id;
    $(".active").removeClass("active");
    $("#a" + id).addClass("active");
    $("#" + id).addClass("active");
  }
  //**************************************************************************************** */
  ngOnInit() {
    if (!this.token_login) this.serverService.status1(2);
    this.refrerr = JSON.parse(<any>localStorage.getItem('refrerr'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
      this.admin = this.user_info.admin;
      this.user_creator = this.user_info.user_creator;
    }
    if (!this.token_login && this.user_info) this.get_logo();
    if (this.refrerr != 2) this.update_last_login();
  }
  update_last_login() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 7048, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {

        }//end if
        else {
          var pe_message = "خطا در ثبت ورود کاربر";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
      }
    )
  }
  open_show_extra_menu() {
    this.show_extra_menu = !this.show_extra_menu;
  }
  get_services_id(id: number) {
    this.menu_id = id;
  }
  open_menu(i: number, link: string, id: number, title: string, section: any) {
    this.matSnackBar.dismiss();
    this.services_id = id;
    this.menu_id_temp = this.menu_id;
    this.menu_id = id;
    if (this.setting_menu == true) {
      this.open_menu_item(i, id, title, section);
      this.menu_id = id;
      this.rstatus_id = 0;
    }
    else if (id == 202) {
      this.invoice_of_person(id);
    }
    else if (id == 226) {
      this.cardex_person(id);
    }
    else if (id == 205) {
      this.open_cardex();
    }
    else if (id == 222) {
      this.open_profile();
    }
    else if (id == 255) {
      this.open_cardex_persenel();
    }
    else {
      //********** */
      this.search_material = "";
      this.search_finance_cardex = "";
      this.search_finance_cardex_persennel = "";
      this.search_finance_newspaper = "";
      this.search_finance = "";
      //********** */
      this.router.navigate(['/home', link, id]);
      this.menu_id = id;
      this.rstatus_id = 0;
    }
  }
  open_profile() {
    this.rstatus_id = 0;
    this.services_id = 0;
    const dialogRef = this.dialog.open(MyProfileComponent, {
      width: '50rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: 2, id: this.user_id, code: 222, ref: 'menu' }
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        this.menu_id = this.menu_id_temp;
      }
    )
  }
  //******************************************************************************** */
  open_account() {
    this.dialog.open(AccountRenewal2Component, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: {
        'user_id': this.user_id,
        'creator': this.creator,
        'expire_date': this.expire_date
      }
    })
  }
  open_dialog_buy_sms() {
    this.dialog.open(BuyChargeComponent, {
      width: '21rem',
      height: 'auto',
      disableClose: true,
      data: {
        'user_id': this.user_id,
        'creator': this.creator,
      }
    })
  }
  get_sms_charge() {
    var obj = {
      'address': 6312,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.sms_charge = res['result'][0].amount;
          this.loading2 = false;
        }//end if
        else {
          this.loading2 = false;
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //******************************************************************************** */
  open_cardex() {
    const dialogRef = this.dialog.open(CardexDetaileComponent, {
      'width': '22rem',
      'height': 'auto',
      data: { res: this.search_material, 'ref': 'home', creator: this.creator }
    })
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.search_material = res;
          this.activatedRoute.queryParams.subscribe(
            (params: Params) => {
              if (params['search'] == undefined) {
                this.menu_id = this.menu_id_temp;
              }
            }
          )
        }
      }
    )
  }
  invoice_of_person(id: number) {
    const dialogRef = this.dialog.open(InvoiceOfPersonComponent, {
      width: '22rem',
      height: 'auto',
      data: { res_search_finance: this.search_finance, creator: this.creator, id: id }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.search_finance = res;
          this.activatedRoute.queryParams.subscribe(
            (params: Params) => {
              if (params['search'] == undefined) {
                this.menu_id = this.menu_id_temp;
              } else {
                if (res.close == true) {
                  this.menu_id = this.menu_id_temp;
                }
              }
            }
          )
        }
      }
    )
  }
  cardex_person(id: number) {
    const dialogRef = this.dialog.open(FinanaceCardexDetaileComponent, {
      width: '22rem',
      height: 'auto',
      data: { res_search_finance_newspaper: this.search_finance_newspaper, res_search_finance_cardex: this.search_finance_cardex, creator: this.creator, id: id }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 226) this.search_finance_cardex = res;

          this.activatedRoute.queryParams.subscribe(
            (params: Params) => {
              if (params['search'] == undefined) {
                this.menu_id = this.menu_id_temp;
              } else {
                if (res.close == true) {
                  this.menu_id = this.menu_id_temp;
                }
              }
            }
          )
        }
      }
    )
  }
  open_cardex_persenel() {
    const dialogRef = this.dialog.open(FinanceCardexPersonnelDetaileComponent, {
      width: '22rem',
      height: 'auto',
      data: { search_array: this.search_finance_cardex_persennel, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.search_finance_cardex_persennel = res;
        }
      }
    )
  }
  open_menu_item(i: number, id: number, title: string, section_id: string) {
    const dialogRef = this.dialog.open(MenuItemsComponent, {
      width: '22rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, title: title, type_task: 2 }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.serverService.send_menu({ title: res.result.site_services_title, id: res.result.site_services_id, section_id: section_id }, 'update');
        }
      }
    )
  }
  go_to_user() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6570, id: this.user_creator }).subscribe(
      (res: any) => {
        //localStorage.clear();
        if (res['status'] == 1) {
          var user_info = {
            user_id: res['result'][0].user_id,
            username: res['result'][0].user_userName,
            user_title: res['result'][0].user_title,
            groups_title: res['result'][0].user_groups_title,
            user_token: res['result'][0].user_token,
            lang: 1,
          };
          localStorage.setItem("user_info", JSON.stringify(user_info));
          localStorage.setItem('status', '1');
          localStorage.setItem('refrerr', '1');
          localStorage.setItem('lang', '1');
          if (this.level == 2) window.open("/home/user/261", "_self");
          else window.open("/home/access/219", "_self");
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //**************************************************************************************************** */
  get_logo() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1038, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          if (res['result'][0].user_logo) {
            this.user_logo = res['result'][0].user_logo_site + "/" + res['result'][0].user_logo;
          }
          else {
            this.user_logo = this.serverService.get_default_user_logo();
          }
          this.level = res['level'];
          this.creator = res['creator'];
          this.similar_admin = res['user_similar_admin'];
          this.sms_access = res['access_sms'];
          this.get_tab();
          if (this.level != 1) {
            this.get_sms_charge();
          }
        }//end if
        else {
          this.serverService.signout();
        }
      }
    )
  }
  get_expire_date() {
    var obj = {
      'address': 6309,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.expire_date = res['expire_date'];
          this.p7 = res['p7'];
          this.p3 = res['p3'];
          this.now_date = res['now_date'];
          this.get_status_expire();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_status_expire(): any {
    this.activatedRoute.queryParams.subscribe(
      (params: Params) => {
        if (params['Status'] == 'OK') {
          return false;
        } else {
          if (this.now_date > this.expire_date) {
            this.dialog.open(AccountRenewalComponent, {
              width: '30rem',
              height: '19rem',
              disableClose: true,
              data: { user_id: this.user_id, creator: this.creator, expire_date: this.expire_date }
            })
          }
        }
      }
    )
  }
  //********************************************************************************************** */
  get_tab() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { address: 1004 }).subscribe(
      (res: any) => {
        this.list_tab = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].site_tab_title) {
              res['result'][i].width = Number(res['result'][i].site_tab_title.length + 5);
            }
            this.list_tab.push(res['result'][i]);
            this.list_tab_temp[res['result'][i].site_tab_id] = new Array();
          }//end for
          this.tab_id = res['result'][0].site_tab_id;
          this.get_section();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }//end get_tab
  get_section() {
    var obj = {
      'address': 1021,
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_section = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_section.push(res['result'][i]);
            for (var j = 0; j < this.list_tab.length; j++) {
              this.list_tab[j].show = false;
              if (this.list_tab[j].site_tab_id == res['result'][i].site_section_tab) {
                this.list_tab_temp[this.list_tab[j].site_tab_id].push(res['result'][i]);
              }
            }
            this.list_menus[res['result'][i].site_section_id] = new Array();
          }//end for
          this.get_menu();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }//end get_section
  get_menu() {
    var obj = {
      'address': 6569,
      'user_id': this.user_id,
      'level': this.level,
      'creator': this.creator,
      'similar_admin': this.similar_admin
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_menu = [];
        if (res['status'] == 1) {
          this.user_setting_menu = res['user_setting_menu'];
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].site_services_img) {
              res['result'][i].src = res['result'][i].site_services_site + "/" + res['result'][i].site_services_img;
            } else {
              res['result'][i].src = this.serverService.get_default_image();
            }
            if (res['result'][i].site_services_id == 197) {
              this.get_rstatus();
              this.activatedRoute.queryParams.subscribe(
                (params: Params) => {
                  if (params['user_reception'] != null) {
                    this.rstatus_id = 0;
                  }
                }
              )
            }
            this.list_menu.push(res['result'][i]);
          }//end for
          this.join_section_menu();
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.serverService.signout();
        }
      }
    )
  }//end get_menu res['result'][i].site_section_tab
  open_add_section() {
    const dialogRef = this.dialog.open(TabComponent, {
      width: '60rem',
      height: 'auto',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        //this.get_tab();
      }
    )
  }
  join_section_menu() {
    for (var i = 0; i < this.list_section.length; i++) {
      for (var j = 0; j < this.list_menu.length; j++) {
        if (this.list_section[i].site_section_id == this.list_menu[j].site_menu_section) {
          this.list_menus[this.list_section[i].site_section_id].push(this.list_menu[j]);
          for (var x = 0; x < this.list_tab.length; x++) {
            if (this.list_tab[x].site_tab_id == this.list_section[i].site_section_tab) {
              this.list_tab[x].show = true;
            }//end if
          }
        }
      }
    }
    var x1 = this.document.location.pathname.split("/")[3];
    var tab_id;
    for (var i = 0; i < this.list_menu.length; i++) {
      if (this.list_menu[i].site_services_id == x1) {
        for (var ii = 0; ii < this.list_section.length; ii++) {
          if (this.list_section[ii].site_section_id == this.list_menu[i].site_menu_section) {
            tab_id = this.list_section[ii].site_section_tab;
            this.select(tab_id);
          }
        }
      }
    }
  }
  get_rstatus() {
    var obj = {
      'address': 1682,
      'user_id': this.user_id,
      'creator': this.creator,
      'level': this.level
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_rstatus = [];
        this.list_rstatus_in_menu = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].repairman_rstatus_logo) {
              res['result'][i].logo = res['result'][i].repairman_rstatus_site_logo + "/" + res['result'][i].repairman_rstatus_logo;
            } else {
              res['result'][i].logo = this.serverService.get_default_image();
            }
            this.list_rstatus.push(res['result'][i]);
            if (res['result'][i].repairman_rstatus_show_menu == 1) this.list_rstatus_in_menu.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  go_to_status(id: number) {
    this.rstatus_id = id;
    this.router.navigate(['/home', 'reception', 170], { queryParams: { rstatus: id } });
    this.menu_id = 0;
  }
  //********************************************************************************************** */
  access_setting_menu() {
    this.setting_menu = !this.setting_menu;
  }
  //***********************************************************************************
  signout() {
    localStorage.removeItem('user_info');
    localStorage.removeItem('status');
    localStorage.removeItem('language');
    localStorage.removeItem('lang');
    localStorage.removeItem('dir');
    window.open("/", "_self");
  }//end signout
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  //************************************************************************************
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }
}
